module.exports = __webpack_public_path__ + "img/shoot-5.c81d4cfb.jpg";